export async function fetchMapboxDrivingRoute(startLon, startLat, endLon, endLat) {
  const Location1Str = `${startLon},${startLat}`;
  const Location2Str = `${endLon},${endLat}`;
  const apiUrl = `https://api.mapbox.com/directions/v5/mapbox/driving/${Location1Str};${Location2Str}?alternatives=true&geometries=geojson&language=en&overview=full&steps=true&access_token=${process.env.MAPBOX_ACCESS_TOKEN}`;
  const fetchResult = await fetch(apiUrl);
  const result = await fetchResult.json();
  if (result.routes && result.routes[0]) {
    const { distance, duration } = result.routes[0];
    return {
      distance: parseFloat(Number(distance / 1609.34).toFixed(2)),
      duration: parseFloat(Number(duration / 60).toFixed(2)),
      direction: [...result.routes[0].geometry.coordinates],
    };
  }
  return null;
}
